import InsertOfferWrapper from "components/InsertOfferWrapper";
import GalleryForm from "scenes/InsertOffer/form/Gallery";
import { CustomAppPage } from "src/types/types";

const Gallery: CustomAppPage = () => (
  <InsertOfferWrapper title="Galerie nemovitosti">
    <GalleryForm buttonNextText="Uložit a pokračovat" />
  </InsertOfferWrapper>
);

Gallery.hasHiddenFooter = true;

export default Gallery;
